import { Typography } from '@material-ui/core';
import { deepMerge } from '@sensenet/client-utils';
import { ReferenceField } from '@sensenet/search-react';
import React from 'react';
import { changeTemplatedValue } from "../helpers.js";
import { defaultLocalization } from "./localization.js";

/**
 * Represents an autocomplete component
 */
export const AutoComplete = props => {
  var _props$localization;

  const localization = deepMerge(defaultLocalization.autoComplete, (_props$localization = props.localization) === null || _props$localization === void 0 ? void 0 : _props$localization.autoComplete);
  const defaultValue = props.fieldValue && props.fieldValue[0].Id || changeTemplatedValue(props.settings.DefaultValue);

  const fetchItems = async fetchQuery => {
    try {
      if (!props.repository) {
        throw new Error('You must pass a repository to this control');
      }

      const result = await props.repository.loadCollection({
        path: '/Root',
        oDataOptions: {
          query: fetchQuery.toString(),
          select: 'all'
        }
      });
      return result.d.results;
    } catch (error) {
      console.error(error.message);
    }
  };

  switch (props.actionName) {
    case 'edit':
    case 'new':
      return /*#__PURE__*/React.createElement(ReferenceField, {
        fieldSetting: props.settings,
        fieldName: props.settings.Name,
        defaultValueIdOrPath: defaultValue,
        onChange: item => {
          var _props$fieldOnChange;

          return (_props$fieldOnChange = props.fieldOnChange) === null || _props$fieldOnChange === void 0 ? void 0 : _props$fieldOnChange.call(props, props.settings.Name, item);
        },
        fetchItems: fetchItems,
        triggerClear: props.triggerClear,
        autoFocus: props.autoFocus
      });

    case 'browse':
    default:
      {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          gutterBottom: true
        }, props.settings.DisplayName), /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          gutterBottom: true
        }, props.fieldValue ? props.fieldValue[0].DisplayName : localization.noValue));
      }
  }
};
//# sourceMappingURL=auto-complete.js.map